import { tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const Container = styled.div<{ color: string; hideOnMobile?: boolean }>`
  position: relative;
  width: 100%;
  background-color: ${(props) => props.color};
  padding: 10px 0;

  ${(props) =>
    props.hideOnMobile &&
    `
    @media (${tabletMax}) {
      display: none;
    }
  `}
`;

export const Logo = styled.img`
  display: block;
  margin: 0 auto;
  max-height: 50px;
`;

export const CloseButton = styled.button`
  display: block;
  position: absolute;
  top: 0;
  right: 10px;
  padding: 10px;
  margin: auto;
  bottom: 0;
`;
